import { ThirdPartyScriptWrapper } from './ThirdPartyScriptWrapper'

export const MarketoForms2 = () => {
	return (
		// biome-ignore lint/correctness/useUniqueElementIds: static ID for third-party script container
		<ThirdPartyScriptWrapper
			id="marketo-forms2"
			scriptContent=""
			ignoreInDevelopment={false}
			scriptOptions={{
				src: 'https://learn.lokalise.com/js/forms2/js/forms2.min.js',
				defer: true,
				strategy: 'lazyOnload',
			}}
		/>
	)
}
